import { render, staticRenderFns } from "./WorkflowEdgeWrapper.vue?vue&type=template&id=69312d30&"
import script from "./WorkflowEdgeWrapper.vue?vue&type=script&lang=ts&"
export * from "./WorkflowEdgeWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports